import {
  buildThoughtChain,
  renderMarkdown,
} from '@/pages/ISWAN_CHAT/components/BubbleListRender/utils';
import { MessageItem, Role } from '@/pages/ISWAN_CHAT/interface';
import { DecodedResponseChunk } from '@/pages/ISWAN_CHAT/utils/decodeResponseChunk';
import { markdown2Text } from '@/pages/ISWAN_CHAT/utils/markdown2Text';
import { setMarkdownContentToCache } from '@/services/AiService';
import { CopyOutlined, DownloadOutlined } from '@ant-design/icons';
import { Bubble, BubbleProps, ThoughtChain } from '@ant-design/x';
import { Button, Card } from 'antd';
import React from 'react';
import './BubbleListRender.fix.css';
import './markdown.css';

export type RenderType = 'chat' | 'agent';

export interface renderBubbleProps {
  messages: MessageItem[];
  extraClass?: string;
  extraProps?: BubbleProps;
  isSuccess?: boolean;
  renderType?: RenderType;
}

const BubbleListRender: React.FC<renderBubbleProps> = (props) => {
  const { messages, extraClass, extraProps, isSuccess, renderType } = props;

  const getBubbleProps = (role: Role, isTyping: boolean): BubbleProps => {
    if (role === 'user') {
      return {
        placement: 'end',
        // avatar: { icon: <UserOutlined />, style: { background: '#87d068' } },
        footer: false,
      };
    }
    if (role === 'assistant') {
      return {
        placement: 'start',
        // avatar: { icon: <RobotOutlined />, style: { background: '#fde3cf' } },
        typing: isTyping ? { step: 1, interval: 30 } : false,
        style: {
          width: '100%',
          minWidth: '100%',
          maxWidth: '100%',
          marginBlock: '20px',
          color: 'rgba(0,0,0,.85)',
        },
      };
    }
    return {};
  };
  const handleCopy = (text: string) => {
    const onlyText = markdown2Text(text);
    navigator.clipboard.writeText(onlyText).then();
  };

  const handleDownload = async (content: string) => {
    let key = await setMarkdownContentToCache({ content: content });
    window.open(
      window.location.origin +
        '/api/office/transferMarkdownByKey?key=' +
        key +
        '&fileName=下载文件.docx',
      '_self',
    );
  };

  return (
    <div className={`__fix__bubbleListRender`}>
      {messages.map((msg, msgIndex) => {
        let _renderType: RenderType;
        if (msg.role === 'user') {
          // role是用户时固定时纯对话
          _renderType = 'chat';
        } else {
          // 如果content里面都是message，说明这是条纯对话，否则说明这是条agent对话
          _renderType =
            renderType || (msg.content.every((e) => e.type === 'message') ? 'chat' : 'agent');
        }

        if (_renderType === 'chat') {
          let content = '';
          if (Array.isArray(msg.content)) {
             content = msg.content.filter((e) => e.type === 'message')
              .map((e) => ('text' in e ? e.text : ''))
              .join('');

            const needTyping = (function () {
              if (isSuccess) return false;
              return msgIndex === messages.length - 1;
            })();

            return (
              <Bubble
                key={msg.key}
                content={content}
                footer={
                  <>
                    <Button
                      color="default"
                      variant="text"
                      size="small"
                      icon={<CopyOutlined />}
                      onClick={() => handleCopy(content)}
                    >
                      复制
                    </Button>
                    <Button
                      color="default"
                      variant="text"
                      size="small"
                      icon={<DownloadOutlined />}
                      onClick={async () => await handleDownload(content)}
                    >
                      下载
                    </Button>
                  </>
                }
                {...getBubbleProps(msg.role, needTyping)}
                messageRender={renderMarkdown}
                className={`${extraClass}`}
                {...extraProps}
              />
            );
          }
        }

        if (_renderType === 'agent') {
          const _content: DecodedResponseChunk[] = [];
          msg.content.forEach((current) => {
            const lastItem = _content.length ? _content[_content.length - 1] : null;

            if (lastItem === null) {
              _content.push(current);
              return;
            }

            // end 只有三种情况，LLM输出结束 和 流程结束 还有 error，error要展示
            if (current.end && current.type === 'ping') {
              return;
            }

            // 合并连续的message chunk
            if (current.type === 'message' && lastItem.type === 'message') {
              lastItem.text += current.text;
              _content[_content.length - 1] = lastItem;
              return;
            }

            // 前一项node被后一项node完成后，更新node而不是添加新的
            if (current.type === 'node' && lastItem?.type === 'node') {
              if (current.status === 'success' && lastItem.status === 'pending') {
                if (current.nodeId === lastItem.nodeId) {
                  _content[_content.length - 1] = current;
                  return;
                }
              }
            }

            _content.push(current);
          });

          return (
            <Card style={{ width: 700, marginBlock: '20px' }} key={msg.key}>
              <ThoughtChain size={'large'} items={buildThoughtChain(_content)} collapsible />
            </Card>
          );
        }

        return <></>;
      })}
    </div>
  );
};

export default BubbleListRender;
